function e(e,t,r,i,n,a,s){try{var o=e[a](s);var u=o.value}catch(e){r(e);return}if(o.done){t(u)}else{Promise.resolve(u).then(i,n)}}function t(t){return function(){var r=this,i=arguments;return new Promise(function(n,a){var s=t.apply(r,i);function o(t){e(s,n,a,o,u,"next",t)}function u(t){e(s,n,a,o,u,"throw",t)}o(undefined)})}}function r(e,t){if(t.has(e)){throw new TypeError("Cannot initialize the same private elements twice on an object")}}function i(e,t){if(t.get){return t.get.call(e)}return t.value}function n(e,t,r){if(t.set){t.set.call(e,r)}else{if(!t.writable){throw new TypeError("attempted to set read only private field")}t.value=r}}function a(e,t,r){if(!t.has(e)){throw new TypeError("attempted to "+r+" private field on non-instance")}return t.get(e)}function s(e,t){var r=a(e,t,"get");return i(e,r)}function o(e,t,i){r(e,t);t.set(e,i)}function u(e,t,r){var i=a(e,t,"set");n(e,i,r);return r}import{tokensAreValid as l,fetchUserInfo as c,decodeTokenProperty as h}from"./utils/tokens";import{formatUserInfo as d}from"./utils/format";/**
 * Thrown when trying to access data from a `Session` class that hasn't been validated yet
 * @class
 * @extends {Error}
 */class f extends Error{constructor(){super("Please validate session before trying to access session info");Error.captureStackTrace(this,f)}}var v=/*#__PURE__*/new WeakMap,p=/*#__PURE__*/new WeakMap,w=/*#__PURE__*/new WeakMap,/** @private whether or not the Session has been validated yet */g=/*#__PURE__*/new WeakMap,/** @private time when the tokens are to expire */y=/*#__PURE__*/new WeakMap,/** @private the logged in user's information */m=/*#__PURE__*/new WeakMap;/**
 * Class used to hold a logged in user's session such as their user information and credentials
 */class k{/**
   * getter for user's authentication token
   * @public
   * @returns the user's authentication token
   */get accessToken(){return s(this,v)}/**
   * getter for the logged in user's identity token
   * @public
   * @deprecated use `userInfo` instead
   * @returns the user's identity token
   */get identityToken(){return s(this,p)}/**
   * getter for Sessions configuration
   * @public
   */get config(){return s(this,w)}/**
   * whether or not the session has been validated yet
   * @public
   */get validated(){return s(this,g)}/**
   * Gets the decoded value of the `identityToken`
   * @public
   * @deprecated use `userInfo` instead
   * @throws {SessionError} if session has not been validated yet
   */get identity(){if(!this.validated){throw new f}return h(this.identityToken,"payload")}/**
   * decoded accessToken getter
   * @public
   * @throws {SessionError} if session has not been validated yet
   * @returns the decoded value of `accessToken`
   */get access(){if(!s(this,g)){throw new f}return h(this.accessToken,"payload")}/**
   * userInfo getter
   * @public
   * @throws {SessionError} if session has not been validated yet
   * @returns the logged in user's information
   */get userInfo(){if(!this.validated){throw new f}return s(this,m)}/**
   * Validates the given tokens and user information against ID2 then freezes this instance
   * @async
   * @public
   * @returns whether the validation was successful or not
   */validate(){var e=this;return t(function*(){// if identity token was not provided, fetch a user info using accessToken
let t;if(!s(e,p)){const r=yield c(s(e,v),s(e,w).authorizationUrl);if(!r){u(e,g,false);u(e,y,0);Object.freeze(e);return false}else{t=r}}const r=yield l(s(e,v),s(e,p),s(e,w).authorizationUrl,s(e,w).clientId,s(e,w).nonce);if(r){var i;u(e,g,r);u(e,y,((i=h(e.accessToken,"payload"))===null||i===void 0?void 0:i.exp)||0);const{accessTokenType:n}=s(e,w);u(e,m,d(s(e,v),s(e,p),{accessTokenType:n,userInfoOverride:t}))}// once validated (or not) freeze object to prevent manipulation
Object.freeze(e);return r})()}/**
   * basic authentication check based on current session
   * @public
   * @throws {SessionError} if session has not been validated yet
   * @returns whether the session instance has been validated and has not yet expired
   */isAuthenticated(){if(!this.validated){throw new f}return this.validated&&!this.hasExpired}/**
   * basic authorization check based on current session
   * @param {string[]} groups - groups to compare against the user's `memberOf`
   * @returns whether or not the logged in user has those one of the given `groups`
   */isAuthorized(e){const t=this.userInfo;const r=e===null||e===void 0?void 0:e.map(e=>e.toUpperCase());if(!t)return false;return this.isAuthenticated()&&(r===undefined||t.memberOf.map(e=>e.toUpperCase()).filter(e=>r.includes(e)).length>0)}/**
   * expiry check for session
   * @throws {SessionError} if session has not been validated yet
   * @returns whether or not the current tokens have expired
   */get hasExpired(){if(!this.validated){throw new f}// Convert date from milliseconds to seconds
const e=Date.now()/1e3;// Is expire time in the past?
return s(this,y)<e}/**
   * @constructor
   * @param accessToken   - the users authentication token supplied by ID2
   * @param identityToken - the users identity token supplied by ID2
   * @param config        - configuration option for the session instance
   * @throws {TypeError} when no `accessToken` or `identityToken` is given
   */constructor(e,t="",r){/**
   * @readonly
   * @private
   * the logged in user's authentication token
   */o(this,v,{writable:true,value:void 0});/**
   * @readonly
   * @private
   * the logged in user's identity token
   */o(this,p,{writable:true,value:void 0});/**
   * @private
   * @readonly stored configuration for this session instance
   * */o(this,w,{writable:true,value:void 0});o(this,g,{writable:true,value:void 0});o(this,y,{writable:true,value:0});o(this,m,{writable:true,value:null});// check for required accessToken
if(typeof e!=="string"||!e.length){throw TypeError("Access token must be provided as a string")}// check for optional identityToken
if(t&&(typeof t!=="string"||!t.length)){throw TypeError("You provided an identity token but it is not a string")}u(this,v,e);u(this,p,t);u(this,w,r);u(this,g,false)}}export default k;